import React, { useState } from "react";

import InfoModal from "../InfoModal";
import AttendanceChild from "./components/AttendanceChild";
import "./styles.scss";

const AttendanceTab = (props) => {
  const { training } = props.newTraining;
  const { addChangeChild, changeStatusChild, loadingStatus } = props;
  const [userInfo, setUserInfo] = useState(null);
  const onUserInfoClick = (item) => (e) => {
    e.stopPropagation();
    setUserInfo(item);
  };

  const onStatusChange = (item) => () => changeStatusChild(item);
  const onChildClick = (item) => () => addChangeChild(item);
  const closeInfoModal = () => setUserInfo(null);

  return (
    <>
      {training.length > 0 ? (
        training.map((item) => (
          <AttendanceChild
            key={item.id}
            item={item}
            onChildClick={onChildClick(item)}
            onUserInfoClick={onUserInfoClick(item)}
            onStatusChange={onStatusChange(item)}
            loadingStatus={loadingStatus}
          />
        ))
      ) : (
        <h3 className="ArrayEmpty">Нет записей</h3>
      )}
      <InfoModal userInfo={userInfo} onClose={closeInfoModal} />
    </>
  );
};

export default AttendanceTab;
